import { render, staticRenderFns } from "./StateSetter.vue?vue&type=template&id=d270da24&scoped=true&"
import script from "./StateSetter.vue?vue&type=script&lang=js&"
export * from "./StateSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d270da24",
  null
  
)

export default component.exports